module.exports = __webpack_public_path__ + "static/media/yash_suryawanshi.5db84316.jpg";